import React from 'react'
import styled from 'styled-components'

import { ReactComponent as CheckMarkSVG } from './assets/checkMark_icon.svg'
import { ReactComponent as IndeterminateCheckMarkSVG } from './assets/indeterminate_checkMark_icon.svg'

import { theme } from '../../../theme'
import { FormLabelHoverState } from '../FormLabel'

import type { CheckboxInputProps } from './types'

export const CheckMark = styled.span`
  height: 20px;
  width: 20px;
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.lavenderSteel};
  border-radius: 4px;
  transition: all ease ${theme.animationSpeed.medium};
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    display: none;
  }
`

export const Label = styled(FormLabelHoverState).attrs({
  as: 'span',
})`
  font-size: 14px;
`

export const CheckMarkIcon = styled((props) => <CheckMarkSVG {...props} />)`
  color: ${theme.colors.white};
`

export const Checkbox = styled.label<
  Pick<CheckboxInputProps, 'indeterminate' | 'isDisabled'>
>`
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  display: flex;
  column-gap: 10px;
  position: relative;
  margin-bottom: 0;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked ~ ${CheckMark} {
    border-color: ${theme.colors.sapphireDark};
    background-color: ${theme.colors.sapphireDark};
  }

  input:checked ~ ${CheckMark}:after {
    display: block;
  }

  input:disabled ~ ${CheckMark} {
    border-color: ${theme.colors.slateGray};
    background-color: ${theme.colors.catskillWhite};
  }

  input:disabled ~ ${CheckMark} > ${CheckMarkIcon} {
    color: ${theme.colors.slateGray};
  }

  input:disabled ~ ${CheckMark}:after {
    display: block;
  }

  input:indeterminate ~ ${CheckMark} {
    border-color: ${theme.colors.second};
    background-color: ${theme.colors.second};
  }

  input:indeterminate ~ ${CheckMark}:after {
    display: block;
  }

  &:hover input ~ ${CheckMark} {
    border-color: ${theme.colors.sapphireDark};
  }

  &:hover input ~ ${Label} {
    color: ${theme.colors.sapphireDark};
  }

  input:checked ~ ${Label} {
    font-weight: 500;
    color: ${theme.colors.sapphireDark};
  }

  input:focus-visible ~ ${CheckMark} {
    outline: 2px solid ${theme.colors.altovita};
    outline-offset: 2px;
    border-radius: 4px;
  }
`

export const IndeterminateCheckMarkIcon = styled((props) => (
  <IndeterminateCheckMarkSVG {...props} />
))`
  color: ${theme.colors.white};
  width: 10px;
  margin-top: 1px;
`
